module.exports = __webpack_public_path__ + "img/zbtj.2d01d770.png";